<template>
  <b-navbar small>
    <b-nav-form>
      <b-nav-item href="#">
        <h1 class="ml-0 page-title">{{ titulo }}</h1>
      </b-nav-item>
      <b-nav-item v-if="toggleLoadingActionsV2" href="#">
        <b-spinner variant="success" label="Spinning"></b-spinner>
      </b-nav-item>
      <b-nav-item href="#" @click="exportarPDF()">
        <i class="fa fa-file fa-fw"></i> Exportar PDF
      </b-nav-item>
      <b-nav-item
        v-if="notaFiscal == true && order.sub_status == 'processing_picking'"
        href="#"
        @click="enviarPorsigepWeb()"
      >
        <i class="fas fa-dolly"></i> Enviar por SIGEP WEB
      </b-nav-item>

      <b-nav-item
        v-if="notaFiscal == true && order.sub_status == 'processing_picking'"
        href="#"
        @click="marcarComoSeparado()"
      >
        <i class="fas fa-dolly"></i> Marcar como Separado
      </b-nav-item>

      <b-nav-item
        v-if="notaFiscal == true && order.sub_status == 'pending_invoice'"
        href="#"
        @click="gerarNotaFiscal()"
      >
        <i class="fas fa-cubes"></i> Gerar nota fiscal
      </b-nav-item>

      <b-nav-item-dropdown text="Imprimir" right v-if="order.status !== 'canceled' &&  order.status !== 'pending'">
        <b-dropdown-item
          v-if="
            notaFiscal == true &&
            (order.status == 'Aprovado' || order.status == 'Approved')
          "
          href="#"
          @click="imprimirListaDePicking()"
        >
          <i class="fas fa-dolly"></i>
          Imprimir Lista de Picking
        </b-dropdown-item>
        <b-dropdown-item
          v-if="notaFiscal == true && order.sub_status == 'waiting_expedition'"
          href="#"
          @click="imprimirNotasFiscais()"
        >
          <i class="fas fa-boxes"></i>
          Imprimir notas fiscais
        </b-dropdown-item>
        <b-dropdown-item href="#" @click="imprimirEtiquetaNota()" >
          <i class="fas fa-boxes"></i>
          Imprimir etiqueta e DANFE simplificada
        </b-dropdown-item>
        <b-dropdown-item href="#" @click="generateLabels()">
          <i class="fas fa-boxes"></i>
          Gerar etiqueta
        </b-dropdown-item>
        <b-dropdown-item
          v-if="notaFiscal == true && order.sub_status == 'waiting_expedition'"
          href="#"
          @click="imprimirEtiquetas()"
        >
          <i class="fas fa-boxes"></i>
          Imprimir etiquetas
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown text="Status" right>
        <b-dropdown-item
          v-if="notaFiscal == true && order.sub_status == 'waiting_expedition'"
          :disabled="order.status === 'canceled' || order.status === 'pending'"
          href="#"
          @click="marcarComoEmbalado()"
        >
          <i class="fas fa-boxes"></i>
          Marcar como embalado
        </b-dropdown-item>
        <b-dropdown-item
          v-if="notaFiscal == true && order.sub_status == 'processing_expedition'"
          :disabled="order.status === 'canceled' || order.status === 'pending'"
          href="#"
          @click="marcarComoEnviado()"
        >
          <i class="fas fa-dolly-flatbed"></i>
          Marcar como enviado
        </b-dropdown-item>
        <b-dropdown-item
          href="#"
          @click="marcarComoEntregue()"
          :disabled="order.status === 'shipping_informed' || order.status === 'canceled' || order.status === 'pending'"
        >
          <i class="fa fa-truck fa-fw"></i>
          Marcar como entregue (status final)
        </b-dropdown-item>
        <b-dropdown-item
          href="#"
          @click="marcarComoCancelado()"
          :disabled="order.status === 'canceled'"
        >
          <i class="fa fa-ban fa-fw"></i>
          Marcar como cancelado (status final)
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-nav-form>
  </b-navbar>
</template>

<script>
import swal from "sweetalert2";
import Action from "./Action.vue";
import barramento from "../../../barramento";
export default {
  props: ["titulo", "notaFiscal", "order", "toggleLoadingActionsV"],
  components: { Action },
  data() {
    return {
      items: [],
      value: null,
      filters: null,
      checked: null,
      loadTotalOrders: null,
      toggleLoadingActionsV2: false,
    };
  },
  methods: {
    generateLabels() {
      barramento.$emit("edit_generate_labels", true);
    },
    optionStatusEntregue(action) {
      barramento.$emit("edit_option_status_entregue", action);
    },
    exportarPDF() {
      barramento.$emit("edit_exportar_pdf", true);
    },
    enviarPorsigepWeb() {
      barramento.$emit("edit_enviar_porsigep_web", true);
    },
    marcarComoSeparado() {
      barramento.$emit("edit_marcar_como_separado", true);
    },
    gerarNotaFiscal() {
      barramento.$emit("edit_gerar_nota_fiscal", true);
    },
    imprimirListaDePicking() {
      barramento.$emit("edit_imprimir_lista_de_picking", true);
    },
    imprimirNotasFiscais() {
      barramento.$emit("edit_imprimir_notas_fiscais", true);
    },
    imprimirTudo() {
      barramento.$emit("edit_imprimir_tudo", true);
    },
    imprimirEtiquetaNota() {
      barramento.$emit("edit_print_danfe_all");
    },
    imprimirGNRE() {
      barramento.$emit("edit_imprimir_gnre", true);
    },
    imprimirEtiquetas() {
      barramento.$emit("edit_imprimir_etiquetas", true);
    },
    marcarComoEmbalado() {
      barramento.$emit("edit_marcar_como_embalado", true);
    },
    marcarComoEnviado() {
      barramento.$emit("edit_marcar_como_enviado", true);
    },
    marcarComoEntregue() {
      barramento.$emit("edit_marcar_como_entregue", true);
    },
    marcarComoCancelado() {
      swal({
        title: this.$t("Você tem certeza?"),
        type: "warning",
        text: this.$t("Realmente deseja cancelar o pedido?"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim, Cancelar pedido!",
      }).then((ok) => {
        if (ok.value === true) {
          this.$emit("canceledOrder")
          barramento.$emit("edit_marcar_como_cancelado", true);
        }
      });
    },
  },
  mounted() {
  },
  beforeDestroy() {
    barramento.$off("action_props_totos");
    barramento.$off("orders_table_checked");
    barramento.$off("orders_filters");
    barramento.$off("orders_load_nav_bar2");
    barramento.$off("orders_status");
  },
  created() {
    barramento.$on("action_props_totos", (objeto) => {
      this.items = objeto.items;
      this.value = objeto.value;
      this.loadTotalOrders = objeto.loadTotalOrders;
      this.filters = objeto.filters;
    });
    barramento.$on("orders_table_checked", (checked) => {
      this.checked = checked;
    });
    barramento.$on("orders_filters", (filters) => {
      this.filters = filters;
    });
    barramento.$on("orders_load_nav_bar2", (status) => {
      this.toggleLoadingActionsV2 = status;
    });
    barramento.$on("orders_status", (objeto) => {
      this.filters = objeto;
    });
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/NavBarActions.vue